const UIActionTypes = {
  SET_SHOW_CHAT_BODY: 'SET_SHOW_CHAT_BODY',
  SET_SHOW_WIDGET_CHAT_BODY: 'SET_SHOW_WIDGET_CHAT_BODY',
  SET_BROWSER_NOTIFICATIONS: 'SET_BROWSER_NOTIFICATIONS',
  SET_SOUND_NOTIFICATIONS: 'SET_SOUND_NOTIFICATIONS',
  SET_ENTER_TO_CALL: 'SET_ENTER_TO_CALL'
};

export default UIActionTypes;
